export var BusinessApiKeyStatus;
(function (BusinessApiKeyStatus) {
    BusinessApiKeyStatus["Active"] = "active";
    BusinessApiKeyStatus["Revoked"] = "revoked";
})(BusinessApiKeyStatus || (BusinessApiKeyStatus = {}));
//# sourceMappingURL=business-api-key-status.const.js.map